import { IconFn, IconSvg } from "../createIcon";

export const BoxesIcon: IconFn = ({ color = "#F56B55", ...props }) => (
  <IconSvg fill="none" viewBox={{ minX: 0, minY: 0, width: 43, height: 38 }} {...props}>
    <path
      d="m.754 21.746 3.138-6.276c.174-.305.48-.523.828-.523h5.84V8.235c0-.13.044-.262.087-.392l3.138-6.32c.175-.305.48-.523.828-.523h13.511c.35 0 .654.174.829.523l3.137 6.276c.044.13.088.261.088.392v6.712h5.84c.349 0 .654.174.828.523l3.138 6.32c.044.13.087.261.087.392v13.947a.894.894 0 0 1-.915.915H1.582a.894.894 0 0 1-.915-.915V22.138c0-.13.043-.262.087-.392Zm9.806-4.969H5.286l-2.222 4.446h7.496v-4.446Zm9.894-13.946H15.18l-2.223 4.445h7.497V2.831Zm7.104 0h-5.274v4.445h7.497l-2.223-4.445Zm2.79 6.276H12.39v12.116h17.956V9.107Zm7.103 7.67h-5.273v4.446h7.496l-2.223-4.446ZM22.284 35.17h17.957V23.053H22.284V35.17Zm-19.787 0h17.957V23.053H2.497V35.17Z"
      fill={color}
      stroke={color}
      strokeWidth={0.75}
    />
  </IconSvg>
);
